export const auth = {
    authModalTitle: 'Authorization required',
    authModalDescription:
        'Authorization is needed to continue this action. Please select from these choices:',
    loginHeading: 'Sign in',
    createAccount: 'Create new account',
    registrationHeading: 'Sign up',
    pleaseFillAll: 'or please fill all the fields to',
    inputWithNameIsRequired: ['Field', 'is required!'],
    orUse: 'or use',
    register: 'Register',
    login: 'Log in',
    nameLabel: 'Name',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    newPasswordLabel: 'New password',
    confirmPasswordLabel: 'Confirm Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    editProfile: 'Edit profile',
    changePassword: 'Change password',
    iHaveRead: [
        'I have read and aggree to the',
        'Terms',
        'and Conditions and',
        'Privacy Policy',
        'to Complete the',
        'process.'
    ],

    passPolicyLength: 'Invalid password: minimum length 8 characters',
    passPolicyUpperCase: 'Invalid password: it has to contain at least 1 Upper case character.',
    passPolicyNumber: 'Invalid password: it has to contain at least 1 numerical digit.',
    passPolicyLowerCase: 'Invalid password: it has to contain at least 1 lower case character.',
    passAndConfirmDontMatch: 'Password and password confirmation do not match.',

    dontHaveAnAccount: "Don't have an account?",
    alreadyHaveAnAccount: 'Already have an account?'
};
